import { DocBaseFragment } from '@cycle-app/graphql-codegen';

type DocWithThreads = { threads: DocBaseFragment['threads'] };

export const getCommentsCount = (doc: DocWithThreads) => doc.threads.edges[0]?.node?.commentsCount ?? 0;
